import axios from "axios";
import RoutingPaths from "../utils/RoutingPaths";

const axiosInstance = axios.create({
  baseURL: "",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,

  (error) => {
    if (error.response && error.response.status === 401) {
      sessionStorage.clear();

      const currentPath = window.location.pathname;
      if (currentPath !== RoutingPaths.LOGIN) {
        window.location.href = RoutingPaths.LOGIN;
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
